export default __webpack_public_path__ + "static/media/Errors Code API Money Transfer.369b8e81.pdf";